module.exports = __webpack_public_path__ + "img/wrench-setting.805d954a.svg";